var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('b-button',{attrs:{"variant":"info"},on:{"click":function($event){return _vm.logOut()}}},[_vm._v(" User ")]),_c('UserTypeForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }